<template>
  <div class="Upload">
    <a-alert
      :message="`${success} uploaded successfully and ${error} failed`"
      type="info"
      style="margin-bottom:10px"
      v-if="uploadList.length"
    />
    <a-upload-dragger
      :disabled="canUpload"
      :multiple="true"
      :beforeUpload="beforeUpload"
      :customRequest="customRequest"
      :showUploadList="false"
      accept="image/jpeg, image/png"
    >
      <p class="ant-upload-drag-icon">
        <a-icon type="inbox" />
      </p>
      <p class="ant-upload-text">Click upload or drag to upload</p>
      <p class="ant-upload-hint">Support multiple uploads, Please check the 《printdoors platform user upload picture commitment guarantee》 before uploading pictures</p>
      <div @click.stop style="text-align:left;padding:10px" class="text">
        <a-checkbox @change="onChange" style="margin-right:5px" :checked="!canUpload"> </a-checkbox>
        <span style="color:red"
          >The uploading of materials shall not involve political sovereignty, politics, terrorism, violence, racial discrimination, feudalism, pornography, gambling, drug abuse and infringement of third-party copyright materials. If there are any of the above and similar problems of disseminating vulgar information and destroying the network ecology, the serious ones will be sealed and investigated for legal responsibility. Thank you for your understanding and cooperation. I have read and agreed to this agreement</span
        >
        <span style="color:blue" class="book" @click="bookVisible = true"
          >《printdoors platform user upload picture commitment guarantee》。</span
        >
      </div>
    </a-upload-dragger>
    <div style="margin: 10px 0">
      <a-checkbox @click="deleteCheck = !deleteCheck" :checked="deleteCheck">Delete suffix with the same name</a-checkbox>
    </div>
    <div class="uploadList">
      <div class="uploadItem" v-for="(value, index) in uploadList" :key="index">
        <a-progress :percent="value.progress" :status="value.status" />
        <div class="itemWrap">
          <span>
            <img :src="value.img" height="50" width="50" alt="" />
            <span style="padding:0 10px" class="text">
              {{ value.name }}
            </span>
          </span>
          <span class="action" v-if="value.status === 'success'">
            <a-icon type="edit" style="margin-right:10px" @click="edit(value)" />
            <a-icon type="delete" @click="del(value.id, index)" />
          </span>
        </div>
        <div class="tip" v-if="value.info">
          {{ value.info }}
        </div>
        <div class="brands" v-if="value.brands && value.brands[1] && value.brands[1].length">
          <span>Risk words:{{ value.brands[1].map(item => item.name).join(',') }}</span>
        </div>
        <div class="risks" v-if="value.risks && value.risks[1] && value.risks[1].length">
          <span>System risk words:{{ value.risks[1].map(item => item.name).join(',') }}</span>
        </div>
      </div>
    </div>
    <a-modal
      title="Edit picture"
      :visible="visible"
      @cancel="visible = false"
      @ok="ok"
      :getContainer="() => document.getElementById('app')"
      width="600px"
      :destroyOnClose="true"
    >
      <EditText ref="editText" />
    </a-modal>
    <a-modal
      title="Printdoors platform user upload picture commitment letter"
      :visible="bookVisible"
      @cancel="bookVisible = false"
      :getContainer="() => document.getElementById('app')"
      width="980px"
      :destroyOnClose="true"
      :footer="null"
    >
      <Book :visibleBook="visibleBook" @bookSubmit="bookSubmit" />
    </a-modal>
  </div>
</template>

<script>
import Book from './book.vue'
import { getOSSInfoType } from '@/api/ossApi'
import axios from 'axios'
import { randomString } from '@/utils/util'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { delUserMaterial, editUserMaterial, getUploadMaterial, ptuUploadMaterial } from '@/api/myGallery'
import EditText from './editText'
import { languageKey } from '@/utils/const'

export default {
  name: 'Upload',
  data() {
    return {
      canUpload: true,
      deleteCheck: false,
      data: null,
      uploadList: [],
      languageKey: languageKey,
      visible: false,
      activeRow: null,
      bookVisible: false,
      fileTypes: ['image/jpeg', 'image/png']
    }
  },
  props: ['url', 'customerCategoryId', 'delUrl'],
  components: { EditText, Book },
  computed: {
    success() {
      return this.uploadList.filter(item => item.status === 'success').length
    },
    error() {
      return this.uploadList.filter(item => item.status === 'exception').length
    }
  },
  methods: {
    visibleBook() {
      this.bookVisible = !this.bookVisible
    },
    bookSubmit() {
      ptuUploadMaterial({ read_agreement: 1 }).then(res => {
        this.canUpload = false
        this.bookVisible = false
      })
    },
    getFileName(name) {
      const index = name.lastIndexOf('.')
      if (this.deleteCheck) {
        return `${name.slice(0, index).replace(/(\(\d\))$/g, '')}`
      } else {
        return name.slice(0, index)
      }
    },
    async customRequest(fileInfo) {
      const fileItem = {}
      fileItem.img = await this.transformBase64(fileInfo.file)
      fileItem.progress = 0
      fileItem.status = 'normal'
      fileItem.info = ''
      fileItem.brands = {}
      fileItem.risks = {}
      fileItem.name = this.getFileName(fileInfo.file.name)
      this.uploadList.push(fileItem)
      const data = this.transformData(this.data, fileInfo.file)
      const formData = new FormData()
      Object.keys(data).map(item => {
        formData.append(item, data[item])
      })
      axios({
        url: data.host,
        method: 'POST',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData,
        onUploadProgress({ lengthComputable, loaded, total }) {
          if (lengthComputable) {
            fileItem.progress = parseInt((loaded / total) * 100)
          }
        }
      })
        .then(res => {
          if (res.status !== 200) {
            fileItem.status = 'exception'
          } else {
            const { id } = res.data.data
            axios({
              url: '/req' + this.url,
              method: 'POST',
              headers: {
                Authorization: 'Bearer ' + this.$ls.get(ACCESS_TOKEN)
              },
              data: {
                oss_file_id: id,
                customer_category_id: this.customerCategoryId ? this.customerCategoryId : undefined,
                is_design: 1
              }
            })
              .then(res => {
                if (res.data.status_code === 200) {
                  const response = res.data.data
                  fileItem.id = response.id
                  fileItem.status = 'success'
                  fileItem.brands = response.brand_infringement_words
                  fileItem.risks = response.risk_words
                  fileItem.material_name_alias = response.material_name_alias || {}
                  fileItem.tags = []
                  fileItem.tagValue = ''
                  fileItem.tagsModel = ''
                  console.log('fileItem===', fileItem)
                } else {
                  console.log('err====111', res)
                  fileItem.status = 'exception'
                  fileItem.info = res.data.msg
                }
                this.isShowEditNameBatch()
              })
              .catch(err => {
                console.log('err====', err)
                fileItem.status = 'exception'
                fileItem.info = err
                this.isShowEditNameBatch()
              })
          }
        })
        .catch(err => {
          fileItem.status = 'exception'
          fileItem.info = err
        })
    },
    async imageReaderFn(file) {
      return new Promise(async (resolve, reject) => {
        const imageReader = new FileReader()
        imageReader.readAsDataURL(file)
        console.log('imageReader===111', imageReader)
        imageReader.addEventListener('loadend', function(e) {
          const img = new Image()
          img.src = e.target.result
          img.onload = () => {
            console.log('img===111', img.width, img.height)
            return resolve({
              width: img.width,
              height: img.height
            })
          }
        })
      })
    },
    async beforeUpload(file) {
      return this.imageReaderFn(file).then(res => {
        console.log('xxxx=======222', res)
        return new Promise(async (resolve, reject) => {
          if (this.fileTypes.indexOf(file.type) === -1) {
            this.$message.error('Incorrect file format')
            // eslint-disable-next-line prefer-promise-reject-errors
            return reject(false)
          } else if (file.size > 50 * 1024 * 1024) {
            this.$message.error('Uploading a single picture cannot exceed 50m')

            // eslint-disable-next-line prefer-promise-reject-errors
            return reject(false)
          } else if (res.width > 20000 || res.height > 20000) {
            this.$message.error('Upload a single image, the width cannot exceed 20000 or the height cannot exceed 20000')
            // eslint-disable-next-line prefer-promise-reject-errors
            return reject(false)
          } else {
            return resolve(true)
          }
        })
      })
      // return new Promise(async (resolve, reject) => {
      //   if (this.fileTypes.indexOf(file.type) === -1) {
      //     this.$message.error('文件格式不正确')
      //     // eslint-disable-next-line prefer-promise-reject-errors
      //     return reject(false)
      //   } else if (file.size > 0.05 * 1024 * 1024) {
      //     this.$message.error('上传单个图片不能超过0.050M')

      //     // eslint-disable-next-line prefer-promise-reject-errors
      //     return reject(false)
      //   } else {
      //     return resolve(true)
      //   }
      // })
    },
    transformData(data, file) {
      const suffixArr = file.name.split('.')
      const suffix = suffixArr.slice(-1)[0]
      console.log('suffix===', suffix)
      console.log('file===', file)
      const name = file.name.substr(0, file.name.lastIndexOf('.'))
      return {
        ...data,
        OSSAccessKeyId: data.accessid,
        key: data.dir + randomString(10) + '.' + suffix,
        'x:name': this.deleteCheck ? `${name.replace(/(\(\d\))$/g, '')}.${suffix}` : file.name,
        file
      }
    },
    transformBase64(file) {
      return new Promise(resolve => {
        const fr = new FileReader()
        fr.readAsDataURL(file)
        fr.onload = e => {
          resolve(e.target.result)
        }
      })
    },
    del(id, index) {
      delUserMaterial({ ids: id }).then(res => {
        this.uploadList.splice(index, 1)
        if (!this.uploadList.length) {
          this.$emit('isBatchBack', false)
        }
      })
    },
    edit(record) {
      this.visible = true
      this.activeRow = record
      this.$nextTick(() => {
        const { editText } = this.$refs
        editText.id = record.id
        editText.language = 1
        editText.record = JSON.parse(JSON.stringify(record))
        editText.tags = record.tags
        editText.form.setFieldsValue({
          name: record.material_name_alias[1]
        })
      })
    },
    ok() {
      const { editText } = this.$refs
      editText.form.validateFields((err, values) => {
        if (!err) {
          console.log('editText===', editText.record)
          // const data = { ...values, ids: editText.id, language: editText.language }
          const data = { id: editText.id, tags: editText.record.tags.join(',') }
          this.languageKey.forEach((it, i) => {
            data[it] = editText.record.material_name_alias[i]
          })
          editUserMaterial(data).then(res => {
            const { brand_infringement_words, risk_words, material_name_alias } = res.data
            this.activeRow.name = material_name_alias && material_name_alias[1] ? material_name_alias[1] : ''
            this.activeRow.brands = brand_infringement_words
            this.activeRow.risks = risk_words
            this.activeRow.material_name_alias = material_name_alias || {}
            this.activeRow.tags = editText.record.tags
            this.visible = false
          })
        }
      })
    },
    onChange() {
      ptuUploadMaterial({ read_agreement: this.canUpload ? 1 : 2 }).then(res => {
        this.canUpload = !this.canUpload
      })
    },
    isShowEditNameBatch() {
      if (this.uploadList.length && this.uploadList.length - this.success - this.error === 0) {
        this.$emit('isBatchBack', true)
      } else {
        this.$emit('isBatchBack', false)
      }
    }
  },

  mounted() {
    getUploadMaterial().then(res => {
      const { read_agreement } = res.data
      if (read_agreement === '2') {
        this.canUpload = true
      } else {
        this.canUpload = false
      }
    })
    getOSSInfoType({ type: 3 }).then(res => {
      this.data = res.data
    })
  }
}
</script>

<style lang="less" scoped>
.Upload {
  position: relative;
  .defaultBtn {
    position: absolute;
    left: 0;
    top: 40px;
    right: 0;
    height: 246px;
    background: transparent;
    cursor: pointer;
    z-index: 9;
  }
  .text {
    &:hover {
      cursor: pointer;
    }
  }
  .uploadList {
    .uploadItem {
      background: #f7f5f5;
      margin: 10px 0;
      border-radius: 5px;
      padding: 5px;
      &:hover {
        cursor: pointer;
      }
      .itemWrap {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .text {
          width: 300px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline-block;
        }
      }
      .tip,
      .brands,
      .risks {
        color: red;
      }
      .action {
        font-size: 16px;
      }
    }
  }
}
</style>
